import API from 'api/hallomart';

/**
 * Constants
 */

export const FETCH_USER = 'user/FETCH_USER';
export const FETCH_USER_OK = 'user/FETCH_USER_OK';
export const FETCH_USER_FAILED = 'user/FETCH_USER_FAILED';


/**
 * Action Creators
 */

export function getCurrentUser() {
	return async (dispatch) => {
		try {
			dispatch({ type: FETCH_USER });
			const payload = await API.getCurrentUser();
			dispatch({ type: FETCH_USER_OK, user: payload.data });
		} catch (err) {
			dispatch({ type: FETCH_USER_FAILED, error: err.response || err.message })
		}
	};
}


/**
 * Reducers
 */

const initialState = {
	isLoading: false,
	error: false,
	errors: {},
	user: {},
	isLoaded: false
};

export default function user(state = initialState, action) {
	switch (action.type) {
		case FETCH_USER:
			return {
				...state,
				error: false,
				errors: {},
				isLoading: true
			};

		case FETCH_USER_OK:
			return {
				...state,
				isLoading: false,
				isLoaded: true,
				user: action.user
			};

		case FETCH_USER_FAILED:
			return {
				...state,
				isLoading: false,
				error: true,
				errors: action.error
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/modules/user.js